import React from "react";

const STYLES = {
  bozza: "bg-slate-100 text-slate-600 border-slate-300",
  inviato: "bg-indigo-50 text-indigo-700 border-indigo-200",
  visualizzato: "bg-violet-50 text-violet-700 border-violet-200",
  accettato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rifiutato: "bg-red-50 text-red-700 border-red-200",
  scaduto: "bg-slate-200 text-slate-600 border-slate-300",
  modifica_richiesta: "bg-amber-50 text-amber-700 border-amber-300",
};
const LABELS = {
  bozza: "Bozza",
  inviato: "Inviato",
  visualizzato: "Visualizzato",
  accettato: "Accettato",
  rifiutato: "Rifiutato",
  scaduto: "Scaduto",
  modifica_richiesta: "Modifica richiesta",
};

export default function StatusBadge({ status, className = "" }) {
  const s = STYLES[status] || STYLES.bozza;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${s} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {LABELS[status] || status}
    </span>
  );
}
